import template from './leave_taken_per_day_count_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class LeaveTakenPerDayCountHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class LeaveTakenPerDayCountHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new LeaveTakenPerDayCountHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'LeaveTakenPerDayCountHelp',
	dialog_class: LeaveTakenPerDayCountHelpPage,
	template: template,
	template_filename: 'translation/dialogs/leave_taken_per_day_count_help',
	provider: 'ps'
};
